import React from 'react';
import KpiTargetDashboard from 'components/pages/salesperson-kpi/personal-dashboard/kpi-target/KpiTargetDashboard';
import PropTypes from 'prop-types';
const ManagerKpiTargetDashboard = () => {
  return <KpiTargetDashboard isFromManagerPage />;
};

ManagerKpiTargetDashboard.propTypes = {
  isFromManagerPage: PropTypes.bool
};

export default ManagerKpiTargetDashboard;
